$.fn.UploaderFile = function(_up, _index)
{
	var _uf = this;
	_uf.up = _up;
	_uf.index = _index;
	_uf.filename = undefined;

	_uf.setFilename = function(filename)
	{
		_uf.filename = filename;
		_uf.find(".cell-filename").html(filename);
	};

	_uf.start = function()
	{
		_uf.removeClass("waiting");
		_uf.addClass("transfering");
	};

	_uf.end = function(response)
	{
		_uf.removeClass("transfering");
		var data = JSON.parse(response),
		linkUrl = _uf.find(".cell-filename").attr("href");
		if (data.success || data.id){
			_uf.attr("data-file-id", data.id);
			_uf.find(".cell-filename").attr("href", data.protected_url);
			if (_uf.up.params.callback != undefined){
				_uf.up.params.callback();
			}
		} else {
			_uf.fadeOut("fast");
			$.slr.notify({
				icon: 'fa fa-exclamation-circle',
				title: "Erreur lors du transfert",
				message: data.error ? data.error : "Le transfert a échoué."
			}, {
				type: 'danger',
				delay: 15
			});
		}
	};

	_uf.abort = function()
	{
		_uf.up.upload('abort', _uf.index);
		_uf.delete();
	};

	_uf.trash = function()
	{
		swal({
			title: "Êtes-vous certain?",
			text: "Voulez-vous vraiment supprimer ce fichier?",
			type: "warning",
			showCancelButton: true,
			confirmButtonClass: "btn-danger",
			confirmButtonText: "Oui, supprimer le fichier",
			cancelButtonText: "Non",
			closeOnConfirm: true,
			closeOnCancel: true
		},
		function(isConfirm) {
			if (isConfirm) {
				_uf.delete();
			}
		});
		return false;
	};

	_uf.delete = function()
	{
		// delete from interface
		_uf.fadeOut("fast");

		// get object id
		var index = 0;
		if (_uf.up.params.model == "contact"){
			index = 0;
		} else {
			index = _uf.up.params.parent.e.get_element_index();
		}

		// build api item
		var item = {
			id : _uf.up.params.id,
			file_id : _uf.data('file-id'),
			index: index,
		};
		if (_uf.up.params.str_id != undefined){
			item.str_id = _uf.up.params.str_id;
		}

		// quick api call
		var request = new FormData();
		request.append("model", _uf.up.params.model);
		if (_uf.up.params.type != undefined){
			request.append("type", _uf.up.params.type);
		}
		request.append("action", "delete_file");
		request.append("data", JSON.stringify(item));

		// add request to queue
		$.slr.db.add(request, _uf.deleted);
		return false;
	};

	_uf.deleted = function()
	{
		if (_uf.up.params.callback != undefined){
			_uf.up.params.callback();
		}
	};

	return function()
	{
		_uf.find(".btn-action-upload-abort").on("click", _uf.abort);
		_uf.find(".btn-action-upload-delete").on("click", _uf.trash);
		return _uf;
	}();
};

$.fn.Uploader = function(_params)
{
	var _up = this;
	_up.params = _params;
	_up.uploader = undefined;
	_up.interface = {
		files: undefined,
		holders: [],
		holder_template: undefined
	};

	_up.clear = function()
	{
		_up.interface.holders.forEach(function(x){
			x.delete();
		});
		_up.interface.holders = [];
	};

	/* Files */
	_up.filestart = function(e, file)
	{
		var file_holder = _up.interface.holders[file.index];
		file_holder.start();
	}

	_up.fileprogress = function(e, file, percent)
	{
		var file_holder = _up.interface.holders[file.index];
		file_holder.find(".progress-bar").css({
			width : percent+"%"
		});
	};

	_up.filecomplete = function(e, file, response)
	{
		var file_holder = _up.interface.holders[file.index];
		file_holder.end(response);
	};

	/* Queue */
	_up.queue_start = function(e, files)
	{
		if (!_up.params.multiple){
			if (files.length > 1){
				_up.uploader.upload("abort");
				return false;
			}
			_up.clear();
		}
		_up.uploader.upload('disable');
		files.forEach(function(file){
			var file_holder = _up.interface.holder_template.clone().UploaderFile(_up, file.index);
			file_holder.addClass("waiting");
			file_holder.setFilename(file.name);
			_up.interface.holders[file.index] = file_holder;
			_up.interface.files.append(file_holder);
		});
	};

	_up.queue_ended = function(e)
	{
		_up.uploader.upload('enable');
	};

	_up.current_files = function()
	{
		_up.interface.files.find(".file-holder").each(function(index, el){
			var file_holder = $(this).UploaderFile(_up, index);
			_up.interface.holders[index] = file_holder;
		});
	};

	_up.reset = function()
	{
		_up.disable();
		_up.interface.holders.forEach(function(x){
			x.remove();
		});
		_up.interface.holders = [];
	};

	_up.disable = function()
	{
		_up.uploader.upload('disable');
	};

	return function()
	{
		// files
		_up.interface.files = _up.find(".files");

		// file holder template
		_up.interface.holder_template = _up.find(".file-holder-template").clone().removeClass("file-holder-template");
		_up.find(".file-holder-template").remove();

		// setup uploader
		_up.uploader = _up.find(".upload").upload({
			action: "/api/multiupload",
			autoUpload: true,
			multiple: _up.params.multiple,
			maxConcurrent: 1,
			maxSize: 268435456,
			label: _up.params.multiple ? 'Sélectionner des documents' : 'Sélectionner un document',
			beforeSend: function(formData, file)
			{
				for (key in _up.params.data){
					formData.append(key, _up.params.data[key]);
				}
				formData.append('id', _up.params.id);
				formData.append('model', _up.params.model);
				if (_up.params.type != undefined){
					formData.append('type', _up.params.type);
				}
				return formData;
			}
		});
		_up.uploader.on('start', _up.queue_start);
		_up.uploader.on('complete', _up.queue_ended);
		_up.uploader.on('filestart', _up.filestart);
		_up.uploader.on('filecomplete', _up.filecomplete);
		_up.uploader.on('fileerror', _up.fileerror);
		_up.uploader.on('fileprogress', _up.fileprogress);

		// load files
		_up.current_files();

		// return
		return _up;
	}();
};
